import { useSyncExternalStore } from "react";
import { InvoiceListRow } from "../types/invoices";

/**
 * Invoices ticked on the invoices list, shared with that list's toolbar.
 *
 * A module-level store rather than component state or a context: App.tsx
 * renders the workspace and the toolbar from separate <Routes> trees, so the
 * grid and the toolbar have no common parent to lift the selection into.
 *
 * Whole rows are kept, not just ids, so the toolbar can show what is selected
 * even after those rows have paged out of the grid.
 */
let selectedInvoices: InvoiceListRow[] = [];
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => selectedInvoices;

export const setSelectedInvoices = (invoices: InvoiceListRow[]) => {
  selectedInvoices = invoices;
  listeners.forEach((listener) => listener());
};

export const clearSelectedInvoices = () => {
  if (selectedInvoices.length > 0) {
    setSelectedInvoices([]);
  }
};

export const useSelectedInvoices = () =>
  useSyncExternalStore(subscribe, getSnapshot);
